"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HTTPClient {
    send(request, next, prev) {
        const xhr = new XMLHttpRequest();
        try {
            xhr.open(request.method, request.url, true);
            for (let header in request.headers) {
                if (request.headers.hasOwnProperty(header)) {
                    xhr.setRequestHeader(header, request.headers[header]);
                    if (header === "Accept") {
                        const responseType = this.mapAcceptHeaderToResponseType(request.headers[header]);
                        if (responseType) {
                            xhr.responseType = responseType;
                        }
                    }
                }
            }
            if (request.body) {
                let data = request.body;
                if (typeof (data) === "string" || data instanceof String) {
                    // Ready to go
                }
                else if (data instanceof FormData) {
                    // Also ready to go
                }
                else {
                    // Try to marshal as a JSON object
                    data = JSON.stringify(data);
                }
                xhr.send(data);
            }
            else {
                xhr.send();
            }
        }
        catch (e) {
            request.error = new Error("Error sending message: " + e.message);
            prev.responseReceived(request);
        }
        xhr.onreadystatechange = (ev) => {
            switch (xhr.readyState) {
                case 4:
                    const headers = {
                        getHeader(name) {
                            return xhr.getResponseHeader(name);
                        }
                    };
                    const response = {
                        headers,
                        response: xhr.response,
                        responseText: (!xhr.responseType || xhr.responseType === "text") ? xhr.responseText : undefined,
                        status: xhr.status,
                        statusText: xhr.statusText
                    };
                    request.response = response;
                    prev.responseReceived(request);
                    break;
            }
        };
    }
    responseReceived(request, next, prev) {
        // HTTPClient should always terminate the chain, i.e., no one will call this
    }
    mapAcceptHeaderToResponseType(acceptType) {
        if (acceptType === "") {
            return undefined;
        }
        // multiple accept should default to blob
        const acceptSeparator = ",";
        if (acceptType.includes(acceptSeparator)) {
            return "blob";
        }
        const blobType = [
            "/json",
            "/text",
            "/xml"
        ].every(type => !acceptType.toLowerCase().trim().includes(type));
        return blobType ? "blob" : undefined;
    }
}
exports.default = HTTPClient;
//# sourceMappingURL=HTTPClient.js.map